import { render, staticRenderFns } from "./recordedVideoList.vue?vue&type=template&id=b584d2f8&scoped=true"
import script from "./recordedVideoList.vue?vue&type=script&lang=js"
export * from "./recordedVideoList.vue?vue&type=script&lang=js"
import style0 from "./recordedVideoList.vue?vue&type=style&index=0&id=b584d2f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b584d2f8",
  null
  
)

export default component.exports